export type PlatformLink = {
  label: string
  href: string
  description?: string
}

function trimUrl(value: string | undefined): string | null {
  const trimmed = value?.trim()
  return trimmed ? trimmed : null
}

/** Resolve OpenAPI docs URL from API base or explicit env override. */
export function resolveApiDocsUrl(): string | null {
  const explicit = trimUrl(import.meta.env.VITE_API_DOCS_URL)
  if (explicit) return explicit

  const base = trimUrl(import.meta.env.VITE_API_BASE_URL) || '/api/v1'
  const normalized = base.replace(/\/$/, '')

  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    return `${normalized}/docs`
  }

  if (typeof window !== 'undefined') {
    return `${window.location.origin}${normalized.startsWith('/') ? normalized : `/${normalized}`}/docs`
  }

  return null
}

/** Configurable shortcuts for operators (store admin login, API docs, etc.). */
export function getPlatformLinks(): PlatformLink[] {
  const links: PlatformLink[] = []

  const storeAdminLogin = trimUrl(import.meta.env.ORG_DASHBOARD_LOGIN_URL)
  if (storeAdminLogin) {
    links.push({
      label: 'Store admin sign-in',
      href: storeAdminLogin,
      description: 'Merchant dashboard login URL (same value as API ORG_DASHBOARD_LOGIN_URL).',
    })
  }

  const apiDocs = resolveApiDocsUrl()
  if (apiDocs) {
    links.push({
      label: 'API documentation',
      href: apiDocs,
      description: 'OpenAPI reference for the Kartly backend.',
    })
  }

  return links
}
